import { useEffect, useState } from "react";
import QRCode from "qrcode";

export default function QrNormaVCF() {
  const [src, setSrc] = useState("");

  useEffect(() => {
    const vcfUrl = `${window.location.origin}/contacts/norma.vcf`;
    QRCode.toDataURL(vcfUrl, { errorCorrectionLevel: "H", margin: 2, width: 320 })
      .then(setSrc)
      .catch(console.error);
  }, []);

  return <img src={src} alt="QR Norma Aldana (.vcf)" />;
}
